import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 71 — "HubSpot freelancer / VA platform-comparison & cost" cluster
 * service links.
 *
 * Every Batch 71 article routes its primary commercial link to
 * /hubspot-revops-architect. The answer-first leads in batch71Content.ts
 * embed the link directly, but the lead-swap idempotency guard can drop the
 * lead when the Quick Answer duplicates the lead text. This map is the
 * RELIABLE fallback: `injectBatchServiceLink` (batchContentOptimizer.ts) wraps
 * the first in-body occurrence of each anchor phrase in a
 * /hubspot-revops-architect link, so the contextual service link always
 * renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH71_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "hubspot-freelancer-rates": {
    url: "/hubspot-revops-architect",
    anchor:
      /freelancer whose rate the team compares to nothing is a hire the team overpays/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-va-cost": {
    url: "/hubspot-revops-architect",
    anchor:
      /cheap HubSpot VA with no portal depth is the most expensive hire of all/i,
    label: "hire a HubSpot RevOps architect",
  },
  "onlinejobs-ph-vs-upwork-hubspot": {
    url: "/hubspot-revops-architect",
    anchor: /flat-fee hire with no portal depth is a hire the rework punishes/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hire-hubspot-specialist-fiverr": {
    url: "/hubspot-revops-architect",
    anchor: /Fiverr gig that skips the portal depth is a hire the team rekeys/i,
    label: "hire a HubSpot RevOps architect",
  },
  "hubspot-freelancer-hourly-rate": {
    url: "/hubspot-revops-architect",
    anchor:
      /beginner freelancer who skips the lifecycle stages is a hire the rework costs a quarter/i,
    label: "hire a HubSpot RevOps architect",
  },
};
